"use client";

import { useCallback, useRef, useState } from "react";

type UseMobileSliderProps = {
  itemsLength: number;
};

export function useMobileSlider({ itemsLength }: UseMobileSliderProps) {
  const sliderRef = useRef<HTMLDivElement | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const handleScroll = useCallback(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const index = Math.round(slider.scrollLeft / slider.clientWidth);
    setActiveIndex(index);
  }, []);

  const scrollToIndex = useCallback(
    (index: number) => {
      const slider = sliderRef.current;
      if (!slider) return;

      const safeIndex = Math.max(0, Math.min(index, itemsLength - 1));

      slider.scrollTo({
        left: safeIndex * slider.clientWidth,
        behavior: "smooth",
      });

      setActiveIndex(safeIndex);
    },
    [itemsLength]
  );

  return {
    sliderRef,
    activeIndex,
    handleScroll,
    scrollToIndex,
  };
}